import { createSelector } from 'reselect'
import { RootStoreState } from '@src/models/app.types'

export const checklistStateSelector = (state: RootStoreState) => state.checklist

export const onboardingChecklistItemsSelector = createSelector(
  checklistStateSelector,
  (checklist) => checklist.onboardingChecklistItems,
)
